import { JsonObject, JsonProperty } from "typescript-json-serializer";
import {MapConfiguration} from "./map-configuration";
import {PortalItemConfiguration} from "./portal-item-configuration";
import {InitialViewConfiguration} from "./view-configuration";

@JsonObject()
export class WebMapConfiguration extends MapConfiguration {
    /**
     * The applicationProperties contains the viewing properties of the WebMap.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-WebMap.html#applicationProperties)
     */
    @JsonProperty()
    declare applicationProperties: any;

    /**
     * The name of the application that authored the WebMap.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-WebMap.html#authoringApp)
     */
    @JsonProperty()
    declare authoringApp: string;
    /**
     * The version of the application that authored the WebMap.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-WebMap.html#authoringAppVersion)
     */
    @JsonProperty()
    declare authoringAppVersion: string;

    /**
     * An array of saved geographic extents that allow end users to quickly navigate to a particular area of interest.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-WebMap.html#bookmarks)
     */
    // @JsonProperty()
    // bookmarks: BookmarkConfiguration[];
    /**
     * When a web map is configured as floor-aware, it has a floorInfo property defined.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-WebMap.html#floorInfo)
     */
    // @JsonProperty()
    // declare floorInfo?: MapFloorInfoProperties;
    /**
     * Information relating to a list of Geotriggers.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-WebMap.html#geotriggersInfo)
     */
    // @JsonProperty()
    // declare geotriggersInfo?: GeotriggersInfoProperties;
    /**
     * The initial view of the WebMap.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-WebMap.html#initialViewProperties)
     */
    @JsonProperty()
    declare initialViewProperties: InitialViewConfiguration;

    /**
     * The portal item from which the WebMap is loaded.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-WebMap.html#portalItem)
     */
    @JsonProperty()
    declare portalItem: PortalItemConfiguration;

    /**
     * Provides multiple slides.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-WebMap.html#presentation)
     */
    @JsonProperty()
    declare presentation: any;

    /**
     * The URL to the thumbnail used for the webmap.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-WebMap.html#thumbnailUrl)
     */
    @JsonProperty()
    declare thumbnailUrl: string;

    /**
     * The utilityNetworks object contains a collection of [UtilityNetworks](https://developers.arcgis.com/javascript/latest/api-reference/esri-networks-UtilityNetwork.html) saved on the web map.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-WebMap.html#utilityNetworks)
     */
    // @JsonProperty()
    // declare utilityNetworks?: CollectionProperties<UtilityNetworkProperties>;

    /**
     * The widgets object contains widgets that are exposed to the user.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-WebMap.html#widgets)
     */
    @JsonProperty()
    declare widgets?: any;

    constructor() {
        super();
    }
}
